/** Resolve stored upload paths to a URL the browser can load (via /api proxy). */
export function resolvePhotoUrl(url) {
  if (!url) return '';
  const s = String(url);
  if (s.startsWith('data:') || s.startsWith('http://') || s.startsWith('https://')) return s;

  const apiBase = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');

  if (s.startsWith('/api/uploads/')) return `${apiBase.replace(/\/api$/, '')}${s}`;
  if (s.startsWith('/uploads/')) return `${apiBase}${s}`;
  if (s.startsWith('uploads/')) return `${apiBase}/${s}`;

  const origin = apiBase.replace(/\/api\/?$/, '');
  return `${origin}${s.startsWith('/') ? s : `/${s}`}`;
}

/** Authenticated fetch URL for part photos (preferred over bare img src). */
export function getPartPhotoFetchUrl(storedPath) {
  if (!storedPath) return '';
  const s = String(storedPath);
  if (s.startsWith('data:') || s.startsWith('http://') || s.startsWith('https://')) return s;

  const apiBase = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');
  let path = s;
  if (!path.startsWith('/')) path = `/${path}`;
  return `${apiBase}/repairs/part-photo?path=${encodeURIComponent(path)}`;
}

/** Workshop / part forms may hold a data-URL preview or a stored path. */
export function resolvePartPhotoSrc(part) {
  if (!part) return '';
  if (part.part_photo) return part.part_photo;
  return resolvePhotoUrl(part.part_photo_url);
}
